@let isQrCodeRedirectRoute = appStateService.isQrCodeRedirectRoute$ | async;
@let hideSideMenu = menuService.hideSideMenu$ | async;
@let numberOfInProgressAppointments = menuService.numberOfInProgressAppointments$ | async;

<warema-app-frame [class.hidden-side-menu]="hideMenu || hideSideMenu || isMenuRestrictedRoute">
    @if (!hideHeader) {
        <warema-header slot="header" [backgroundSrc]="appStateService.headerImgUrl$ | async">
            <a slot="warema-header-logo" [routerLink]="appStateService.headerUrl$ | async"></a>
            <h1 class="tagline">
                <span>{{ 'HEADER_NAME' | translate }}</span>
            </h1>
            <div class="right-slot" slot="right">
                <div class="wrapper">
                    @if ((authenticationApiService.user$ | async)?.isTestUser) {
                        <span class="test-mode">TEST MODE</span>
                    }
                </div>
                <warema-header-button
                    id="cookies-button"
                    [closeLabel]="'CLOSE' | translate"
                    [icon]="'cookie'"
                    [label]="'COOKIES' | translate"
                    (click)="userCentricsService.showSecondLayer()"
                />
                @if (!isQrCodeRedirectRoute) {
                    <warema-header-button
                        id="burger-menu-button"
                        trigger-for="shared-burger-menu"
                        [class.inside-shop]="isShopRoute"
                        [closeLabel]="'CLOSE' | translate"
                        [icon]="'burgerMenu'"
                        [label]="'MENU_LABEL' | translate"
                    />
                }
            </div>
        </warema-header>
    }
    <warema-shared-header-menu
        appName="warema-plus"
        toolname="warema-plus"
        [headerName]="'HEADER_NAME' | translate"
        [hideLanguage]="hideHeader"
        [hideShopLinks]="isQrCodeRedirectRoute"
        [isLoggedIn]="authenticationApiService.loggedIn$ | async"
        [showAppSpecificMenu]="showMobileMenuEntries"
        [showCountryMenu]="true"
        [showLoginControls]="!isQrCodeRedirectRoute"
        [showWaremaAGB]="true"
        [tenantConfigSettings]="(tenantConfig.settings$ | async)!"
        [version]="buildVersion ?? 'local'"
        (clickRouteRedirect)="handleClickRouteRedirect($event)"
        (clickUrl)="menuService.goToUrl($event[0], $event[1])"
        (login)="authenticationApiService.login()"
        (logout)="authenticationApiService.logout()"
        (setLanguage)="appStateService.setLanguage($event)"
    >
        @if (!hideHeader) {
            @for (menu of menuService.burgerMenus$ | async; track menu) {
                @if (!menu.parentMenuId) {
                    @for (menuItem of menu.menuItems; track menuItem) {
                        <warema-header-menu-item
                            [icon]="menuItem.iconPath ? menuItem.iconPath : null"
                            [label]="menuItem.displayName | translate"
                            [selected]="menuItem.selected"
                            [triggerFor]="menuItem.triggerFor"
                            (click)="menuItem.triggerFor ? undefined : menuService.goToMenuItem(menuItem)"
                        />
                    }
                }
            }
        }
        @if (!hideHeader) {
            <ng-container slot="submenus">
                @for (menu of menuService.burgerMenus$ | async; track menu) {
                    @if (menu.parentMenuId) {
                        <warema-header-menu
                            [id]="menu.triggerId"
                            [navigateBackText]="'BACK' | translate"
                            [parentMenuId]="menu.parentMenuId"
                            [triggerId]="menu.triggerId"
                        >
                            @for (menuItem of menu.menuItems; track menuItem) {
                                <warema-header-menu-item
                                    [icon]="menuItem.iconPath ? menuItem.iconPath : null"
                                    [label]="menuItem.displayName | translate"
                                    [selected]="menuItem.selected"
                                    [triggerFor]="menuItem.triggerFor"
                                    (click)="menuService.goToMenuItem(menuItem)"
                                />
                            }
                        </warema-header-menu>
                    }
                }
            </ng-container>
        }
    </warema-shared-header-menu>

    <warema-side-navigation-bar
        slot="side-navigation-bar"
        theme="light"
        [class.hidden-side-menu]="hideMenu || hideSideMenu || isMenuRestrictedRoute"
        [toggleLabel]="'COLLAPSE' | translate"
        (collapsed)="appStateService.setIsSideMenuExtended(false)"
        (expanded)="appStateService.setIsSideMenuExtended(true)"
    >
        @for (menuItem of (menuService.sideMenu$ | async)?.menuItems; track menuItem) {
            <div class="menu-tab-navigation-div" (click)="menuService.goToMenuItem(menuItem)">
                @if (menuItem.menuItemType === menuItemType.PROFILE || menuItem.menuItemType === menuItemType.SHOP) {
                    <warema-side-navigation-bar-divider />
                }
                <div class="menu-item-wrapper">
                    <warema-side-navigation-bar-item
                        theme="light"
                        [attr.data-cy]="'menu-item-' + menuItem.displayName"
                        [class.active]="menuItem.selected"
                        [icon]="menuItem.iconPath"
                        [id]="menuItem.displayName"
                        [label]="menuItem.displayName | translate"
                        [title]="menuItem.displayName | translate"
                    />
                    @if (menuItem.menuItemType === menuItemType.APPOINTMENTS && numberOfInProgressAppointments > 0) {
                        <div
                            atBadgePosition="below after"
                            class="appointments-counter"
                            matBadgeOverlap="false"
                            matBadgeSize="small"
                            [matBadge]="numberOfInProgressAppointments"
                        ></div>
                    }
                </div>
            </div>
        }
    </warema-side-navigation-bar>

    <div
        class="outer-content-container"
        [class.no-padding-bottom]="appStateService.isShopFabricsOrBrochuresRoute$ | async"
        [class.sun-center]="hideHeader"
    >
        <div class="content-container">
            <ngx-loading-bar color="#d4001a" [fixed]="false" [includeSpinner]="false" />
            <router-outlet #outlet="outlet" />
        </div>
    </div>
</warema-app-frame>

<!-- trigger build !! -->
